import { abi } from "./abi.js";
import manifest from "./manifest.js";

export const release = { abi, manifest };
